import { AppSportsBookState } from 'src/domains/sportsbook/state/AppSportsBook.state';
import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { EventHeaderCaptionName, EventHeaderCaption } from './EventGroupHeader.style';
import { CompetitionId } from 'src_common/common/websocket2/id/WebsocketId';
import { Collapse } from 'src/ui/components/collapse/sports/04/Collapse';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface PropsType {
    label: string;
    selections: Array<string>;
    open: boolean;
    onToggle: () => void;
    competitionId: CompetitionId | null;
    dataTest?: string;
    hideSelectionsHeader?: boolean;
}

export const EventGroupHeader = observer('EventGroupHeader', (props: PropsType) => {
    const { competitionId, dataTest, hideSelectionsHeader, label, onToggle, open, selections } = props;
    const common = useCommon();
    const appSportsBookState = AppSportsBookState.get(common);
    const unifiedComponentConfig = ConfigComponents.get(common).unifiedComponentConfig;
    const eventsListState = appSportsBookState.eventsListState.get(competitionId);

    const isOutrightsMarket = hideSelectionsHeader ?? eventsListState.isOutrightsMarket();

    return (
        <Collapse
            dataTest={dataTest}
            isOpen={open}
            handleToggle={onToggle}
            title={label}
        >
            {open
                ? isOutrightsMarket === false &&
                  selections.map((name, key) => (
                      <EventHeaderCaption
                          key={key}
                          variant={unifiedComponentConfig.componentVariants.sportsbookVariant}
                      >
                          <EventHeaderCaptionName>{name.charAt(0).toUpperCase()}</EventHeaderCaptionName>

                          <EventHeaderCaptionName>{name}</EventHeaderCaptionName>
                      </EventHeaderCaption>
                  ))
                : null}
        </Collapse>
    );
});
